<div class="main-menu">
	<li>
		<a routerLink="/" routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
	</li>
	<li>
		<a routerLink="/series" routerLinkActive="is-active">Series</a>
	</li>
	<li>
		<a routerLink="/videos" routerLinkActive="is-active">Video's</a>
	</li>
	<li>
		<a routerLink="/vissers" routerLinkActive="is-active">Vissers</a>
	</li>
	<li>
		<a routerLink="/artikelen" routerLinkActive="is-active">Artikelen</a>
	</li>
	<li *ngIf="showDiscounts">
		<a routerLink="/kortingscodes" routerLinkActive="is-active">Kortingscodes</a>
	</li>

	<div class="search-wrapper">
		<kwo-search-input></kwo-search-input>
	</div>
</div>